<template>
    <vue-draggable-resizable class="ql-position-cue-marker"
        :style="{backgroundColor:cueColor(cue)}"
        :handles="[]"
        :x="cuePosLeft" :y="cuePosTop"
        :w="cue.width || 20" :h="cue.height || 20"
        :minw="10" :minh="10"
        :parent="true"
        :draggable="editable && !locked"
        @dragging="onDrag"
        @dragstop="onDragStop"
        @activated="onActivate" @deactivated="onDeactivate" >
        <md-tooltip md-direction="top" v-if="!locked && editable">Move</md-tooltip>
    </vue-draggable-resizable>
</template>

<script>
// 

import { mapGetters } from 'vuex';
import vueDragResize from 'vue-draggable-resizable';
/**
 * Component For...
 */
const CuePositionMarker = {
    name: 'CuePositionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function() {
        return {
            dragging: false
        };
    },
    computed: {
        ...mapGetters([
            'layerByCue'
        ]),
        layer: function() {
            return this.layerByCue(this.cue);
        },
        cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        }
    },
    methods: {
        cueColor(cue) {
            const layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop(x, y) {
            const cue = {
                ...this.cue,
                x: x,
                y: y
            };
            this.dragging = false;
            this.$emit('updateCue', cue);
        },
        onActivate() {
            this.$emit('activated');
        },
        onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': vueDragResize
    },

    mounted: function() {
    }
};

export default CuePositionMarker;
</script>

<style lang="scss">
.ql-position-cue-marker {
    width: 5px;
    height: 5px;
    opacity: 1;
    cursor: move;
    color: black;
    pointer-events: fill;
    border-radius: 15px;
}

.ql-marker-icon {
    text-rendering: optimizeLegibility;
    vertical-align: middle;
}

.ql-selection-cue-marker .resizeable {
    pointer-events: stroke;
    cursor: nwse-resize;
}

.ql-selection-cue-marker .moveable {
    pointer-events: fill;
    cursor: move;
}
</style>


// WEBPACK FOOTER //
// cue-position-marker.vue?6e8615dd